class MainMenuService {
    constructor ($q, $http, ngAuthSettings, $httpParamSerializerJQLike) {
      this.$q = $q;
      this.$http = $http;
      this.ngAuthSettings = ngAuthSettings;
      this.$httpParamSerializerJQLike= $httpParamSerializerJQLike;
    }
    

  }
  
  MainMenuService.$inject = ['$q','$http', 'ngAuthSettings', '$httpParamSerializerJQLike'];
  
  export default MainMenuService;
  


/** WEBPACK FOOTER **
 ** C:/wamp64/www/FRONTENDS/PROYECTOS SIESA/Projects_Azure/motos_paisa/NUEVO/motos-y-motos-el-paisa/www/components/main-menu/main-menu.service.js
 **/